import { render, staticRenderFns } from "./SidebarDefault.vue?vue&type=template&id=c7cdef56&scoped=true"
import script from "./SidebarDefault.vue?vue&type=script&lang=js"
export * from "./SidebarDefault.vue?vue&type=script&lang=js"
import style0 from "./SidebarDefault.vue?vue&type=style&index=0&id=c7cdef56&prod&lang=scss"
import style1 from "./SidebarDefault.vue?vue&type=style&index=1&id=c7cdef56&prod&scoped=true&lang=css"
import style2 from "./SidebarDefault.vue?vue&type=style&index=2&id=c7cdef56&prod&scoped=true&lang=css"
import style3 from "./SidebarDefault.vue?vue&type=style&index=3&id=c7cdef56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7cdef56",
  null
  
)

export default component.exports